import React from 'react';
import WebsiteNavbar from '../../components/WebsiteUI/WebsiteNavbar';
import BookDemoWrapper from './BookDemoWrapper';
import bookDemoSteps from '../../data/bookDemoSteps';
import './BookDemoPage.css';

const BookDemoPage = () => {
  const steps = bookDemoSteps.steps;
  const defaultImage = steps[0]?.image || '/assets/website/onboarding/intro.png';

  return (
    <>
      <WebsiteNavbar />
      <main className="demo-page">
        <BookDemoWrapper steps={steps} defaultImage={defaultImage} />
      </main>
    </>
  );
};

export default BookDemoPage;
